<template>
  <sfs-form-modal
    :id="modalId"
    size="md"
    title="Import Work Order Charges to Update"
    @on-hide="resetFormData"
  >
    <imports-form
      description="Update work order charges."
      @on-submit="createUpdateWorkOrderChargesImport"
      @on-save="handleSave"
      @on-cancel="closeModal"
      :key="formKey"
    >
      <template #downloads>
        <b-row>
          <b-col cols="12">
            <sfs-download-button
              label="Download Template"
              filename="Work Order Charges to Update Template.xlsx"
              :file-provider="$importsAPI.getUpdateWorkOrderChargesTemplate"
            />
          </b-col>
        </b-row>
      </template>
    </imports-form>
  </sfs-form-modal>
</template>

<script>
import ImportsForm from './Form.vue';
import formModalMixin from '@/mixins/formModalMixin';

export default {
  name: 'UpdateWorkOrderChargesImportsAddModal',
  mixins: [formModalMixin],
  components: {
    ImportsForm,
  },
  data() {
    return {
      modalId: 'update-work-order-charges-imports-add-modal',
    };
  },
  methods: {
    createUpdateWorkOrderChargesImport(data, handleCreate) {
      handleCreate(this.$importsAPI.updateWorkOrderChargesCreate(data));
    },
    handleSave(data) {
      if (this.$route.name != 'imports') {
        this.$router.push({ name: 'imports' });
      } else {
        this.closeModal();
      }
      this.$emit('on-save', data);
    },
  },
};
</script>
